module.exports = __webpack_public_path__ + "files/8b9f4f9aaee6f7d6fdab036a49852194.png";